/* Quote form: every row is a book picked from our shelves (type a title, author or ISBN and choose from the list).
   Each book needs at least PER copies. The number of titles does not matter. Under that, the books can go to the cart instead.
   The rows fold into one "Books" field when sent. Without scripts the plain textarea is used.
   ?from=cart brings the cart in; the cart is left as it is, the customer removes books themselves. */
(function(){
  var PER=5,MIN=PER;

  var done=document.querySelector('[data-mb-qdone]');
  if(done){
    done.scrollIntoView({block:'center'});done.focus({preventScroll:true});return;
  }
  var f=document.querySelector('[data-mb-quote]');if(!f)return;
  var rows=f.querySelector('[data-q-rows]'),tpl=f.querySelector('[data-q-tpl]'),bar=f.querySelector('[data-q-bar]'),
      sum=f.querySelector('[data-q-sum]'),books=f.querySelector('[data-q-books]'),send=f.querySelector('.mb-qsend'),
      min=f.querySelector('[data-q-min]'),minTxt=f.querySelector('[data-q-mintxt]'),toCart=f.querySelector('[data-q-tocart]'),
      fromCart=f.querySelector('[data-q-fromcart]');
  function all(){return Array.prototype.slice.call(rows.querySelectorAll('[data-q-row]'))}
  function inp(r,k){return r.querySelector('[data-q="'+k+'"]')}
  function val(r,k){return (inp(r,k).value||'').trim()}
  function picked(r){return !!r.getAttribute('data-vid')}
  function qty(r){return parseInt(val(r,'qty'),10)||0}
  function esc(t){var d=document.createElement('div');d.textContent=t==null?'':t;return d.innerHTML}
  function plural(n,a,b){return n+' '+(n===1?a:b)}
  function ord(e){e=String(e==null?'':e).trim();if(!/^\d+$/.test(e))return e;var n=+e,m=n%100;return e+((m>10&&m<14)?'th':({1:'st',2:'nd',3:'rd'})[n%10]||'th')}

  // ---------- the shelf list ----------
  var shelf=null,shelfP=null;
  function loadShelf(){
    if(shelf)return Promise.resolve(shelf);
    // mb-find.js (which provides mbLoad) may run after this script, so wait for the page to finish loading scripts
    if(!shelfP)shelfP=new Promise(function(ok){
      if(window.mbLoad||document.readyState==='complete')ok();else{document.addEventListener('DOMContentLoaded',function(){ok()});window.addEventListener('load',function(){ok()})}
    }).then(function(){return window.mbLoad?window.mbLoad('/collections/all','local'):[]}).then(function(l){shelf=l;return l},function(){shelfP=null;return []});
    return shelfP;
  }
  function norm(s){return (s||'').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').replace(/&/g,' and ').replace(/[^a-z0-9]+/g,' ').trim()}
  function digits(s){return (s||'').replace(/[^0-9xX]/g,'').toLowerCase()}
  function search(q){
    var d=digits(q),words=norm(q).split(' ').filter(Boolean);if(!words.length)return [];
    var used={};all().forEach(function(r){if(picked(r))used[r.getAttribute('data-vid')]=1});
    var out=[];
    shelf.forEach(function(i){
      if(used[i.vid])return;
      var hay=(i.nt||norm(i.t))+' '+(i.na||norm(i.a))+' '+i.isbn,s=0;
      if(d.length>=5&&i.isbn&&i.isbn.indexOf(d)>-1)s=100;
      else{for(var k=0;k<words.length;k++){if(hay.indexOf(words[k])<0)return}
        s=10;var nt=i.nt||norm(i.t);if(nt.indexOf(words.join(' '))===0)s+=20;else if(nt.indexOf(words[0])===0)s+=8}
      if(i.av)s+=3;
      out.push({i:i,s:s});
    });
    out.sort(function(a,b){return b.s-a.s||a.i.t.length-b.i.t.length});
    return out.slice(0,8).map(function(x){return x.i});
  }

  // ---------- the suggestion list under the title box ----------
  var pop=document.createElement('div');pop.className='mb-qsug';pop.setAttribute('role','listbox');pop.id='mb-qsug';pop.hidden=true;
  var popRow=null,popItems=[],popAt=-1;
  function closePop(){pop.hidden=true;popRow=null;popItems=[];popAt=-1;all().forEach(function(r){inp(r,'title').setAttribute('aria-expanded','false')})}
  function showPop(r){
    var q=val(r,'title');
    if(q.length<2){closePop();return}
    if(!shelf){pop.innerHTML='<p class="mb-qsug__msg">Loading our shelves…</p>';place(r);loadShelf().then(function(){if(popRow===r)showPop(r)});return}
    popItems=search(q);popAt=popItems.length?0:-1;
    pop.innerHTML=popItems.length?popItems.map(function(i,ix){
      return '<button type="button" role="option" class="mb-qsug__it'+(ix===0?' is-on':'')+'" data-sug="'+ix+'">'+
        (i.img?'<img src="'+esc(i.img)+'" alt="" loading="lazy">':'<span class="ph"></span>')+
        '<span class="tx"><b>'+esc(i.t)+'</b><small>'+esc([i.a,i.ed?ord(i.ed)+' edition':'',i.v].filter(Boolean).join(' · '))+'</small></span>'+
        (i.av?'':'<em>Out of stock</em>')+'</button>'}).join('')
      :'<p class="mb-qsug__msg">No book on our shelves matches “'+esc(q)+'”. Try the author or ISBN, or <a href="/#find">ask us to find it</a>.</p>';
    place(r);
  }
  function place(r){popRow=r;r.appendChild(pop);pop.hidden=false;inp(r,'title').setAttribute('aria-expanded','true')}
  function mark(ix){popAt=ix;pop.querySelectorAll('[data-sug]').forEach(function(b,k){b.classList.toggle('is-on',k===ix);if(k===ix)b.scrollIntoView({block:'nearest'})})}

  function choose(r,i){
    r.setAttribute('data-vid',i.vid);r.setAttribute('data-h',i.h);r.setAttribute('data-isbn',i.isbn||'');
    inp(r,'title').value=i.t;inp(r,'author').value=i.a||'';inp(r,'ed').value=i.ed?ord(i.ed):'';
    var q=inp(r,'qty');if(qty(r)<PER)q.value=PER;
    r.classList.add('is-picked');r.classList.remove('is-bad');closePop();paint();q.focus();q.select();
  }
  function unpick(r){
    if(!picked(r))return;
    ['data-vid','data-h','data-isbn'].forEach(function(a){r.removeAttribute(a)});
    inp(r,'author').value='';inp(r,'ed').value='';r.classList.remove('is-picked');
  }

  // ---------- rows ----------
  function add(focus,d){
    var n=tpl.content.firstElementChild.cloneNode(true);rows.appendChild(n);
    if(d){inp(n,'title').value=d.title||'';if(d.qty!=null)inp(n,'qty').value=d.qty;if(d.vid){n.setAttribute('data-vid',d.vid);n.classList.add('is-picked')}}
    if(focus)inp(n,'title').focus();paint();return n;
  }
  function tally(){
    var t=0,c=0,loose=0,few=0;
    all().forEach(function(r){
      if(!val(r,'title'))return;
      if(!picked(r)){loose++;return}
      t++;c+=qty(r);if(qty(r)<PER)few++;
    });
    return {t:t,c:c,loose:loose,few:few};
  }
  function paint(){
    var x=tally(),ok=x.t>0&&!x.loose&&!x.few&&x.c>=MIN;
    if(!x.t&&!x.loose)sum.textContent='Add your books above';
    else if(x.loose)sum.textContent='Pick '+(x.loose===1?'the book':'each book')+' from the list that opens as you type';
    else if(x.few)sum.textContent='Each book needs '+PER+' copies or more';
    else if(x.c<MIN)sum.textContent=plural(x.c,'copy','copies')+' so far. A quote needs '+MIN+' or more.';
    else sum.textContent=plural(x.t,'book','books')+' · '+plural(x.c,'copy','copies')+' in your quote';
    send.setAttribute('aria-disabled',ok?'false':'true');send.classList.toggle('is-off',!ok);
    var under=x.t>0&&!x.loose&&(x.few||x.c<MIN);
    min.hidden=!under;
    var mh=f.querySelector('[data-q-minhead]');if(mh&&under)mh.textContent=x.few?'Each book needs '+PER+' copies or more':'A quote needs '+MIN+' copies or more in total';
    if(under)minTxt.textContent=(x.few?'A quote needs '+PER+' or more copies of each book':'Add '+plural(MIN-x.c,'more copy','more copies')+' to ask for a quote')+', or order these straight from the cart. Cart orders are dispatched in 1 to 2 days.';
    all().forEach(function(r){
      var q=inp(r,'qty');r.classList.toggle('is-few',picked(r)&&qty(r)<PER);
      q.setCustomValidity(picked(r)&&qty(r)<PER?'At least '+PER+' copies of each book':'');
    });
    var rm=rows.querySelectorAll('[data-q-rm]');rm.forEach(function(b){b.disabled=rm.length<2});
  }
  rows.hidden=false;bar.hidden=false;books.hidden=true;books.removeAttribute('required');

  // bring the cart in, or start with three empty rows
  function fillFromShelf(){
    loadShelf().then(function(items){
      var by={};items.forEach(function(i){by[String(i.vid)]=i});
      all().forEach(function(r){var i=by[r.getAttribute('data-vid')];if(!i)return;
        r.setAttribute('data-h',i.h);r.setAttribute('data-isbn',i.isbn||'');
        inp(r,'title').value=i.t;inp(r,'author').value=i.a||'';inp(r,'ed').value=i.ed?ord(i.ed):''});
    });
  }
  if(/[?&]from=cart\b/.test(location.search)){
    fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(c){
      if(!c.items.length){for(var i=0;i<3;i++)add(false);return}
      c.items.forEach(function(it){add(false,{title:it.product_title,qty:it.quantity,vid:it.variant_id})});
      fromCart.hidden=false;fromCart.querySelector('b').textContent=plural(c.items.length,'book','books')+' from your cart';
      fillFromShelf();paint();
    }).catch(function(){for(var i=0;i<3;i++)add(false)});
  }else{for(var i=0;i<3;i++)add(false)}
  loadShelf();

  f.addEventListener('click',function(e){
    var s=e.target.closest('[data-sug]');if(s&&popRow){choose(popRow,popItems[+s.getAttribute('data-sug')]);return}
    if(e.target.closest('[data-q-add]')){add(true);return}
    var rm=e.target.closest('[data-q-rm]');if(rm){var r=rm.closest('[data-q-row]');if(r===popRow)closePop();r.remove();paint();return}
    if(e.target.closest('[data-q-more]')){var last=all().filter(picked).pop();if(last){var q=inp(last,'qty');q.focus();q.select()}}
  });
  document.addEventListener('click',function(e){if(!pop.hidden&&!e.target.closest('.mb-qsug')&&!e.target.closest('[data-q="title"]'))closePop()});
  f.addEventListener('input',function(e){
    var r=e.target.closest('[data-q-row]');if(!r)return;
    if(e.target.matches('[data-q="title"]')){unpick(r);r.classList.remove('is-bad');showPop(r)}
    paint();
  });
  f.addEventListener('focusin',function(e){
    if(e.target.matches('[data-q="title"]')){var r=e.target.closest('[data-q-row]');if(!picked(r)&&val(r,'title'))showPop(r)}
  });
  f.addEventListener('focusout',function(e){
    if(!e.target.matches('[data-q="title"]'))return;var r=e.target.closest('[data-q-row]');
    setTimeout(function(){if(r.contains(document.activeElement)&&document.activeElement.closest('.mb-qsug'))return;
      if(val(r,'title')&&!picked(r))r.classList.add('is-bad')},150);
  });
  f.addEventListener('keydown',function(e){
    var r=e.target.closest('[data-q-row]');if(!r)return;
    if(e.target.matches('[data-q="title"]')&&popRow===r&&!pop.hidden){
      if(e.key==='ArrowDown'&&popItems.length){e.preventDefault();mark((popAt+1)%popItems.length);return}
      if(e.key==='ArrowUp'&&popItems.length){e.preventDefault();mark((popAt-1+popItems.length)%popItems.length);return}
      if(e.key==='Escape'){closePop();return}
      if(e.key==='Enter'){e.preventDefault();if(popAt>-1)choose(r,popItems[popAt]);return}
    }
    if(e.key!=='Enter')return;
    e.preventDefault();if(r===all().slice(-1)[0])add(true);else inp(r.nextElementSibling,'title').focus();
  });

  // under the minimum: put the picked books in the cart, once the customer agrees
  toCart.addEventListener('click',function(){
    var want=all().filter(picked);if(!want.length)return;
    var found=want.map(function(r){return {id:+r.getAttribute('data-vid'),quantity:Math.max(1,qty(r)),t:val(r,'title')}});
    var msg='Add '+plural(found.length,'book','books')+' to your cart?\n\n'+found.map(function(x){return '• '+x.t+' × '+x.quantity}).join('\n')+'\n\nCart orders are dispatched in 1 to 2 days.';
    if(!confirm(msg))return;
    toCart.disabled=true;var label=toCart.textContent;toCart.textContent='Adding…';
    // books that came from the cart are already in it; only new ones are added
    fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(c){
      var inCart={};c.items.forEach(function(it){inCart[it.variant_id]=1});
      var fresh=found.filter(function(x){return !inCart[x.id]});
      return fresh.length?fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:fresh.map(function(x){return {id:x.id,quantity:x.quantity}})})}):null;
    }).then(function(){location.href='/cart'})
      .catch(function(){alert('Something went wrong. Please try again.');toCart.disabled=false;toCart.textContent=label});
  });

  // the two cards at the top: jump to the books, or take the picked books (or the customer) to the cart
  var goB=f.querySelector('[data-q-gobooks]'),goC=f.querySelector('[data-q-gocart]');
  if(goB)goB.addEventListener('click',function(e){e.preventDefault();var s=document.getElementById('q-books');if(s)s.scrollIntoView({behavior:'smooth',block:'start'});var r=all()[0];if(r)inp(r,'title').focus({preventScroll:true})});
  if(goC)goC.addEventListener('click',function(e){if(all().filter(picked).length){e.preventDefault();toCart.click()}});

  f.addEventListener('submit',function(e){
    var x=tally();
    if(x.loose||x.few||!x.t||x.c<MIN){
      e.preventDefault();
      var bad=all().filter(function(r){return val(r,'title')&&!picked(r)})[0];
      if(bad){bad.classList.add('is-bad');var t=inp(bad,'title');t.focus();showPop(bad);return}
      var few=all().filter(function(r){return picked(r)&&qty(r)<PER})[0];
      if(few){var q=inp(few,'qty');q.reportValidity();q.focus();return}
      if(!x.t){var t1=inp(all()[0],'title');t1.setCustomValidity('Pick at least one book');t1.reportValidity();t1.addEventListener('input',function z(){t1.setCustomValidity('');t1.removeEventListener('input',z)});return}
      min.scrollIntoView({block:'center'});return;
    }
    var lines=[];
    all().filter(picked).forEach(function(r){
      var bits=[val(r,'title')];if(val(r,'author'))bits.push(val(r,'author'));if(val(r,'ed'))bits.push(val(r,'ed')+' edition');
      if(r.getAttribute('data-isbn'))bits.push('ISBN '+r.getAttribute('data-isbn'));
      lines.push((lines.length+1)+'. '+bits.join(' | ')+' | Copies: '+qty(r));
    });
    books.value='Total: '+x.c+' copies\n'+lines.join('\n');
    // also drop the request into the Medallied desk queue (sent as plain text so no preflight is needed)
    var desk=(f.getAttribute('data-desk')||'').replace(/\/$/,'');
    if(desk){
      var g=function(n){var el=f.querySelector('[name="contact['+n+']"]');return el?(el.type==='checkbox'?(el.checked?el.value:''):el.value.trim()):''};
      var body={name:g('name'),phone:g('phone'),email:g('email'),institution:g('Institution'),course:g('Course and year'),city:g('City'),pin:g('PIN code'),
        neededBy:g('Needed by'),outOfPrint:g('If out of print'),notes:g('body'),
        lines:all().filter(picked).map(function(r){return {title:val(r,'title'),author:val(r,'author'),ed:val(r,'ed'),isbn:r.getAttribute('data-isbn')||'',handle:r.getAttribute('data-h')||'',variantId:r.getAttribute('data-vid'),qty:qty(r)}})};
      try{fetch(desk+'/intake',{method:'POST',keepalive:true,headers:{'Content-Type':'text/plain'},body:JSON.stringify(body)}).catch(function(){})}catch(err){}
    }
  });
})();
